import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=3ba49ec0&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"
import style0 from "./Home.css?vue&type=style&index=0&id=3ba49ec0&prod&lang=css&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba49ec0",
  null
  
)

export default component.exports